<template>
  <div id="main-navbar">
    <large-navbar
      :languageOptions="languageOptions"
      :defaultLanguage="selectedLanguage"
      :navigations="whiteListedNavigations"
      class="d-none d-md-block"
    />
    <mobile-navbar
      :languageOptions="languageOptions"
      :defaultLanguage="selectedLanguage"
      :navigations="whiteListedNavigations"
      class="d-md-none d-xs-block d-sm-block"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LargeNavbar from "./LargeNavbar";
import MobileNavbar from "./MobileNavbar";

export default {
  name: "MainNavbar",
  props: {},
  components: {
    LargeNavbar,
    MobileNavbar,
  },
  data: () => ({
    navigations: [
      {
        // its own label, not the product name the Cryptos dropdown reuses
        titleKey: "globals.navigation.platformToken",
        link: "/products/ebso",
      },
      {
        titleKey: "globals.navigation.products",
        groupId: "products",
        subItems: [
          {
            titleKey: "globals.products.eBlockStock.title",
            descriptionKey: "globals.products.eBlockStock.description",
            link: "/products/ebso",
          },
          {
            titleKey: "globals.products.crowdX.title",
            descriptionKey: "globals.products.crowdX.description",
            link: "/products/crowdx",
          },
          {
            titleKey: "globals.products.commingSoon.title",
            descriptionKey: "globals.products.commingSoon.description",
            link: ""
          },
          {
            titleKey: "globals.products.holoverz.title",
            descriptionKey: "globals.products.holoverz.description",
            link: "/products/holoverz",
          },
        ],
      },
      {
        titleKey: "globals.navigation.forBusiness",
        groupId: "forBusiness",
        subItems: [
          {
            titleKey: "globals.businesses.ourServices.title",
            descriptionKey: "globals.businesses.ourServices.description",
            link: "/our-services",
          },
          {
            titleKey: "globals.businesses.joinPlatform.title",
            descriptionKey: "globals.businesses.joinPlatform.description",
            link: "/joinplatform",
          },
        ],
      },
      {
        titleKey: "globals.navigation.wallet",
        link: "/wallet",
      },
      {
        titleKey: "globals.navigation.aboutUs",
        link: "/about-us",
      },
      {
        // the blog teaser on the home page; it links on to the full blog itself
        titleKey: "globals.navigation.blog",
        link: "/#blog",
      },
      // TODO: temporary remove
      // {
      //   titleKey: "globals.navigation.support",
      //   link: "/support",
      // },
    ],
    selectedLanguage: undefined,
  }),
  created() {
    this.setSelectedLanguage();
  },
  computed: {
    ...mapGetters({
      getSelectedLanguage: "settings/getSelectedLanguage",
    }),
    languageOptions() {
      const options = [];
      this.$enums.supportedLanguages.forEach((element) => {
        const helper = {};
        helper.value = element.value;
        helper.label = this.$t(element.label);
        helper.shortLabel = this.$t(element.shortLabel);
        options.push(helper);
      });
      return options;
    },
    whiteListedNavigations() {
      let enabledRoutes = []
      this.$router.options.routes.forEach(item => {
        if (item.children.length > 0) {
          return enabledRoutes.push(...item.children.map(subitem => subitem.path))
        }
      })

      let filteredNavigations = this.navigations.reduce((result, item) => {
        if (item.subItems) {
          let tmp = {...item}
          if (!tmp.subItems.link) {
            result.push(tmp)
          } else {
            tmp.subItems = item.subItems.filter(subitem => enabledRoutes.includes(subitem.link.substring(1)) || !subitem.link)
            result.push(tmp)
          }
        } else if (enabledRoutes.includes(item.link.substring(1))) {
          result.push(item)
        } else if (item.link.includes("http") || item.link.startsWith("/#")) {
          // in-page anchors have no route of their own to whitelist against
          result.push(item)
        }
        return result
      }, [])
      return filteredNavigations
    }
  },
  watch: {
    getSelectedLanguage: {
      immediate: true,
      handler() {
        this.setSelectedLanguage();
      },
    },
  },
  methods: {
    setSelectedLanguage() {
      if(this.getSelectedLanguage) {
        this.selectedLanguage = this.languageOptions.find((x) => {
          return x.value == this.getSelectedLanguage;
        });
      } else {
        this.selectedLanguage = this.languageOptions.find((x) => {
          return x.value == process.env.VUE_APP_I18N_FALLBACK_LANG_CODE;
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global.scss";

#main-navbar {
  position: fixed;
  width: 100vw;
  z-index: 3;
  background: white;
  top: 0;
  left: 0;
}
</style>
